import { useNavigate } from "react-router-dom";

export const SlipsRoutesComponent = () => {
  const navigate = useNavigate();
  const ArrayData = [
    {
      label: "T4",
      items: [
        {
          label: "List",
          command: () => {
            navigate("/taxslip/t4/list")
          },
        },
        {
          label: "Setup",
          command: () => {
            navigate("/taxslip/t4/setup")
          },
        },
        {
          label: "Summary",
          command: () => {
            navigate("/taxslip/t4/summary")
          },
        },
        {
          label: "Summary Reduced EI",
          command: () => {
            navigate("/taxslip/t4/summary-reduced-ei")
          },
        },
        {
          label: "Import CSV",
          command: () => {
            navigate("/taxslip/t4/import")
          },
        },
        {
          label: "Import XML",
          command: () => {
            navigate("/taxslip/t4/import-xml")
          },
        },
      ],
    },
    {
      label: "T4A",
      items: [
        {
          label: "List",
          command: () => {
            navigate("/taxslip/t4a/list")
          },
        },
        {
          label: "Setup",
          command: () => {
            navigate("/taxslip/t4a/setup")
          },
        },
        {
          label: "Summary",
          command: () => {
            navigate("/taxslip/t4a/summary")
          },
        },
        {
          label: "Import CSV",
          command: () => {
            navigate("/taxslip/t4a/import")
          },
        },
        {
          label: "Import XML",
          command: () => {
            navigate("/taxslip/t4a/import-xml")
          },
        },
      ],
    },
    {
      label: "T5",
      items: [
        {
          label: "List",
          command: () => {
            navigate("/taxslip/t5/list")
          },
        },
        {
          label: "Setup",
          command: () => {
            navigate("/taxslip/t5/setup")
          },
        },
        {
          label: "Summary",
          command: () => {
            navigate("/taxslip/t5/summary")
          },
        },
        {
          label: "Import CSV",
          command: () => {
            navigate("/taxslip/t5/import")
          },
        },
        {
          label: "Import XML",
          command: () => {
            navigate("/taxslip/t5/import-xml")
          },
        },
      ],
    },
    {
      label: "T3",
      items: [
        {
          label: "List",
          command: () => {
            navigate("/taxslip/t3/list")
          },
        },
        {
          label: "Setup",
          command: () => {
            navigate("/taxslip/t3/setup")
          },
        },
        {
          label: "Summary",
          command: () => {
            navigate("/taxslip/t3/summary")
          },
        },
        {
          label: "Settings",
          command: () => {
            navigate("/taxslip/t3/settings")
          },
        },
        {
          label: "Import CSV",
          command: () => {
            navigate("/taxslip/t3/import")
          },
        },
        {
          label: "Import XML",
          command: () => {
            navigate("/taxslip/t3/import-xml")
          },
        },
      ],
    },
    {
      label: "RL-1",
      items: [
        {
          label: "List",
          command: () => {
            navigate("/taxslip/rl1/list")
          },
        },
        {
          label: "Setup",
          command: () => {
            navigate("/taxslip/rl1/setup")
          },
        },
        {
          label: "Summary",
          command: () => {
            navigate("/taxslip/rl1/summary")
          },
        },
        {
          label: "Settings",
          command: () => {
            navigate("/taxslip/rl1/settings")
          },
        },
        {
          label: "Import CSV",
          command: () => {
            navigate("/taxslip/rl1/import")
          },
        },
        {
          label: "Import XML",
          command: () => {
            navigate("/taxslip/rl1/import-xml")
          },
        },
      ],
    },
    {
      label: "RL-3",
      items: [
        {
          label: "List",
          command: () => {
            navigate("/taxslip/rl3/list")
          },
        },
        {
          label: "Setup",
          command: () => {
            navigate("/taxslip/rl3/setup")
          },
        },
        {
          label: "Summary",
          command: () => {
            navigate("/taxslip/rl3/summary")
          },
        },
        {
          label: "Import CSV",
          command: () => {
            navigate("/taxslip/rl3/import")
          },
        },
        {
          label: "Import XML",
          command: () => {
            navigate("/taxslip/rl3/import-xml")
          },
        },
      ],
    },
    {
      label: "RL-16",
      items: [
        {
          label: "List",
          command: () => {
            navigate("/taxslip/rl16/list")
          },
        },
        {
          label: "Setup",
          command: () => {
            navigate("/taxslip/rl16/setup")
          },
        },
        {
          label: "Summary",
          command: () => {
            navigate("/taxslip/rl16/summary")
          },
        },
        {
          label: "Settings",
          command: () => {
            navigate("/taxslip/rl16/settings")
          },
        },
        {
          label: "Import CSV",
          command: () => {
            navigate("/taxslip/rl16/import")
          },
        },
        {
          label: "Import XML",
          command: () => {
            navigate("/taxslip/rl16/import-xml")
          },
        },
      ],
    },
  ];

  return {
    SlipsRoutes: ArrayData
  }
}